var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenInNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 15.8574C3.3375 15.8574 2.98438 15.7105 2.69063 15.4168C2.39687 15.123 2.25 14.7699 2.25 14.3574V3.85742C2.25 3.44492 2.39687 3.0918 2.69063 2.79805C2.98438 2.5043 3.3375 2.35742 3.75 2.35742H9V3.85742H3.75V14.3574H14.25V9.10742H15.75V14.3574C15.75 14.7699 15.6031 15.123 15.3094 15.4168C15.0156 15.7105 14.6625 15.8574 14.25 15.8574H3.75ZM7.275 11.8824L6.225 10.8324L13.2 3.85742H10.5V2.35742H15.75V7.60742H14.25V4.90742L7.275 11.8824Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenInNew);
export default __webpack_public_path__ + "static/media/open_in_new.a2f28141fd912c505d29b974b083f49b.svg";
export { ForwardRef as ReactComponent };